import React, { useEffect, useState } from "react";
import { List, Typography, ListItemAvatar, Avatar, ListItemText, Divider, Box, Button, useTheme, useMediaQuery, TextField } from '@mui/material';
import CarritoData from "./CarritoData";
import { ccyFormat } from "../../helpers/helper";
import { Deposit, Modal, RadioGroup } from "..";
import { TYPE_SALE } from "../../helpers/enums";

const CarritoViewData = ({
  rows,
  onRemoveItem,
  onCancel,
  onSell,
  users,
  width = '40%',
  onEditItem,
  onChangePrice,
  withDescription = true
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [name, setName] = useState("");
  const [selectedUser, setSelectedUser] = React.useState("");
  const [data, setData] = useState(rows);
  const [openModal, setOpenModal] = useState(false);

  const handleOnRemoveItem = (item) => {
    onRemoveItem && onRemoveItem(item)
  }

  const handleOnEditItem = item => {
    onEditItem && onEditItem(item)
  }

  const handleChangePrice = (typePrice, value, row) => {
    onChangePrice && onChangePrice(typePrice, value, row)
  }

  const totalSale = data.reduce((acc, item) => acc + (item.prices_sold?.sale_price * item.quantity_sold), 0)

  useEffect(() => {
    console.log("add Carrito view Data")
    setData(rows)
    if (rows && rows.length === 0) {
      onCancel && onCancel()
    }
  }, [rows])

  return (
    <Box sx={{ width: '100%' }} alignItems='center' display='flex' flexDirection='column' >
      <List sx={{ width: isMobile ? '100%' : width, bgcolor: 'background.paper', background: '#C1D0CD' }}>
        {data && data.map(row => {
          return <>
          <CarritoData
            key={row.article_id}
            data={{
              tittle: row.name,
              subtittle: row.prices_sold.sale_price * row.quantity_sold,
              description: row.description,
              quantity: row.quantity_sold,
              image: row.image,
              discount_info: row.discount_applied ? {
                offer_name: row.discount_applied.offer_name,
                discount_text: row.discount_applied.discount_percentage 
                  ? `-${row.discount_applied.discount_percentage}%`
                  : `-$${row.discount_applied.discount_amount}`,
                original_price: row.original_price,
                discount_amount: row.discount_applied.discount_amount
              } : null
            }}
            onRemove={() => handleOnRemoveItem(row)}
            onEdit={handleOnEditItem}
            onChangePrice={(typePrice, value) => handleChangePrice(typePrice, value, row)}
            withDescription={withDescription}
          />
          <Divider variant="inset" component="li" />
        </>
        }
        )}
      </List>
      <Typography display='flex' paddingX={2} flexDirection='row' justifyContent='space-between' variant='h5' width='100%' alignItems='center'>
        <Box><Typography variant="h5"><span>{`P. TOTAL: $`}</span></Typography></Box>
        <Box><Typography variant="h5"><span>{ccyFormat(totalSale)}</span></Typography></Box>
      </Typography>
      <TextField
        id="investment"
        label="Nombre pedido"
        type="text"
        variant="standard"
        fullWidth
        sx={{ paddingX: 2 }}
        // error={errors.investment}
        // helperText={errors.investment}
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
      <Divider />
      <RadioGroup options={users} onValueChange={value => { console.log(value); setSelectedUser(value) }} />
      <Box sx={{ mt: 5, display: "flex", width: '100%' }} flexDirection='row' justifyContent='space-between'>
        <Button
          type="submit"
          variant="contained"
          //onClick={onClose}
          // disabled={saving}
          color="error"
          onClick={() => onCancel && onCancel()}
        >Cancelar</Button>
        {data && data.length > 0 && <>
          <Button
            type="submit"
            variant="contained"
            disabled={selectedUser === ""}
            color="info"
            // disabled={!isValid || saving}
            onClick={() => setOpenModal(true)}
          >
            Reservar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            disabled={selectedUser === ""}
            onClick={() => onSell && onSell({ name: name, delivery: true, vendor: selectedUser })}
          >
            Entregar
          </Button>
        </>}
      </Box>
      <Modal
        open={openModal}
        Content={() =>
          <Deposit
            maxQuantity={totalSale}
            onClose={() => setOpenModal(false)}
            onConfirm={(quantity) => onSell && onSell({ name: name, delivery: false, vendor: selectedUser, deposit: quantity })}
          />}

      />
    </Box>
  );
}

export default CarritoViewData;